module.exports = __webpack_public_path__ + "static/zatca-59b4c6e101e56089ab6ffb67bc2120a1.png";